import breadcrumbSchema from '../schemas/breadcrumb';
import courseSkeletonSchema from '../schemas/course';
import videoObjectSchema from '../schemas/videoObject';

const classSchema = ({
  courseDetails = {},
  classInfo,
  videoInfo = {},
  canonicalURL
}) => {
  const { goal } = courseDetails;
  if (!goal) return {};

  const graph = [];
  if (courseDetails.name) {
    graph.push(courseSkeletonSchema(courseDetails));
  }
  const breads = [
    {
      name: 'Home',
      url: 'https://unacademy.com'
    },
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goal.name,
      url: goal.permalink
    },
    {
      name: 'Free classes & tests',
      url: `${goal.permalink}/classes`
    },
    {
      name: classInfo.name,
      url: classInfo.permalink
    }
  ];
  graph.push(breadcrumbSchema(breads));

  if (videoInfo.videoUrl && canonicalURL) {
    graph.push(
      videoObjectSchema({
        name: videoInfo.name || classInfo.name,
        description: courseDetails.description,
        thumbnail:
          videoInfo.thumbnail || videoInfo.coverPhotoV1 || videoInfo.coverPhoto,
        createdAt: videoInfo.liveAt || videoInfo.createdAt,
        videoUrl: videoInfo.videoUrl,
        lessonDuration: videoInfo.videoDuration || videoInfo.lessonDuration,
        viewCount: videoInfo.attendance,
        permalink: canonicalURL
      })
    );
  }

  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };
  return schema;
};

export default classSchema;
